const config = {
  API_URL: 'https://verichain-api-19746570250.africa-south1.run.app',
  APP_NAME: 'Falcon',
  APP_TAGLINE: 'Manufacturer Intelligence Portal.',
  APP_URL: 'https://falcon.verichain.co.za',
};

export default config;